import axios from "axiosConfig";
import React, {useState, useEffect} from "react";
import {Link, useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {Container, Row} from "react-bootstrap";
import {checkEmailStatus, verifyEmail} from "actions/auth";
import {isVerified} from "actions/auth";

import OpenedLetterIcon from "assets/icons/opened-letter-icon.png";
import ClosedLetterIcon from "assets/icons/closed-letter-icon.png";
import TextView from "./TextView";
import {hideModal, showLogin} from "actions/ui_control";

function VerifyEmail({isEmailVerified, setIsEmailVerified}) {
  const {user: userData} = useSelector(state => state.auth);
  const [loading, setLoading] = useState(false);
  const [resendVerificationEmail, setResendVerificationEmail] = useState(false);
  const [canResend, setCanResend] = useState(true);
  const [message, setMessage] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    const lastResendTimestamp = localStorage.getItem("lastResendTimestamp");
    if (lastResendTimestamp) {
      const currentTime = new Date().getTime();
      const elapsedTime = currentTime - parseInt(lastResendTimestamp, 10);
      const resendCooldown = 3600000; // 1 hour in milliseconds

      if (elapsedTime < resendCooldown) {
        setResendVerificationEmail(false);
        setCanResend(false);
      } else {
        localStorage.removeItem("lastResendTimestamp");
      }
    }
  }, []);

  const handleContinue = e => {
    // navigate("/dashboard");
    dispatch(hideModal());
    setIsEmailVerified(true);
    dispatch(showLogin());
  };

  const handleConfirm = e => {
    setLoading(true);
    dispatch(checkEmailStatus()).then(() => {
      const isEmailVerified = dispatch(isVerified());

      if (!isEmailVerified) {
        setMessage(
          "Email Verification Required: Please verify your email to proceed."
        );
        setTimeout(() => setMessage(""), 5000); // Clear message after 5 seconds
      } else {
        setIsEmailVerified(isEmailVerified);
      }

      setLoading(false);
    });
  };

  const handleResendVerificationEmail = e => {
    const lastResendTimestamp = localStorage.getItem("lastResendTimestamp");
    const currentTime = new Date().getTime();
    const resendCooldown = 3600000; // 1 hour in milliseconds

    if (
      !lastResendTimestamp ||
      currentTime - parseInt(lastResendTimestamp, 10) >= resendCooldown
    ) {
      setLoading(true);
      axios
        .post("/api/auth/resend-verification-email/")
        .then(() => {
          setResendVerificationEmail(true);
          setCanResend(false);
          localStorage.setItem("lastResendTimestamp", currentTime.toString());
        })
        .catch(error => {
          try {
            setMessage(
              error.response.data.message ||
              "We couldn't complete your request."
            );
            setTimeout(() => setMessage(""), 5000); // Clear message after 5 seconds
          } catch (e) {
            setMessage("We couldn't complete your request.");
            setTimeout(() => setMessage(""), 5000); // Clear message after 5 seconds
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return (
    <Container>
      <Row>
        {/* Header section */}
        {isEmailVerified ? (
          <TextView
            image={OpenedLetterIcon}
            title={"Mail successfully confirmed"}
            text={
              "You have confirmed the email and you can fully use the platform."
            }
            handleClick={handleContinue}
            loading={loading}
            btnText={"Continue"}
          />
        ) : (
          <TextView
            image={ClosedLetterIcon}
            title={"Confirm Email"}
            text={
              <>
                An email has been {resendVerificationEmail ? "resent" : "sent"}{" "}
                to{" "}
                <span style={{color: "#A5E1AD"}}>
                  {userData?.user?.email}
                </span>
                .
              </>
            }
            handleClick={handleConfirm}
            loading={loading}
            btnText={"Continue"}
          >
            <p>Please check your inbox to confirm your email.</p>
            {canResend && (
              <small>
                If you didn't receive the email, click{" "}
                <Link onClick={handleResendVerificationEmail}>
                  Resend Email
                </Link>
                .
              </small>
            )}
          </TextView>
        )}
        {message && (
          <div className="form-group mt-3">
            <div className="alert alert-danger" role="alert">
              {message}
            </div>
          </div>
        )}
      </Row>
    </Container>
  );
}

export default VerifyEmail;
